import React from 'react';
import { Image, LayoutDashboard, LayoutGrid, Settings, UtensilsCrossed } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import ArabAliLogo from '../../../components/ArabAliLogo';
import { useAdminContext } from '../../../context/AdminContext';

const navItems = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/menu/categories', label: 'Categories', icon: LayoutGrid },
  { to: '/admin/menu/items', label: 'Items', icon: UtensilsCrossed },
  { to: '/admin/settings', label: 'Settings', icon: Settings },
  { to: '/admin/media', label: 'Media', icon: Image },
];

const AdminSidebar: React.FC = () => {
  const { draftWorkspace } = useAdminContext();
  const settings = draftWorkspace?.settings;
  const restaurantName = settings?.name?.trim() || 'Your Restaurant';

  return (
  <aside className="admin-panel admin-sidebar hidden w-80 flex-col gap-8 p-6 xl:flex">
    <div>
      <ArabAliLogo
        logoImage={settings?.logoImage}
        name={restaurantName}
        subtitle={settings?.subtitle || 'Admin Workspace'}
        location={settings?.location || 'Update your live menu'}
        badgeLabel="Admin CMS"
      />
      <div className="mt-6 rounded-[28px] border border-white/10 bg-white/5 p-4">
        <div className="text-[11px] uppercase tracking-[0.35em] text-amber-100/45">Backstage</div>
        <p className="mt-3 text-sm leading-7 text-white/55">
          Update the menu, prices, photos, colors, logo, and business details for {restaurantName}, then publish when everything looks right.
        </p>
      </div>
    </div>

    <nav className="space-y-3">
      {navItems.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-semibold uppercase tracking-[0.18em] transition ${
              isActive
                ? 'bg-gradient-to-r from-amber-300 to-orange-500 text-[#2b1209]'
                : 'bg-white/5 text-white hover:bg-white/10'
            }`
          }
        >
          <Icon className="h-4 w-4" />
          {label}
        </NavLink>
      ))}
    </nav>
  </aside>
  );
};

export default AdminSidebar;
